










import Vue from 'vue';

import Hero from '../components/HomeHero.vue';
import Intro from '../components/MyIntro.vue';
import Projects from '../components/LoadProject.vue';
import Stack from '../components/WorkStack.vue';
import Comments from '../components/CommentsSection.vue';

export default Vue.extend({
  name: 'home',
  components: {
    Hero,
    Intro,
    Projects,
    Stack,
    Comments,
  },
});
